export default __webpack_public_path__ + "static/media/f4.d9724a62.png";